import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 195px;
  position: relative;
`;

export const CardBox = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
`;

export const CardFileTypeImage = styled.img`
  width: 80%;
  height: 80%;
`;

export const Checkbox = styled.input`
  position: absolute;
  top: 6px;
  left: 6px;
  width: 16px;
  height: 16px;
`;
